/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';

export default class GuideRoute extends Route {
  beforeModel() {
    this.transitionTo('apps.app.home');
  }
}
